import * as React from "react";
// import { pure } from 'recompose'
import * as i18next from "i18next";
import * as Lodash from "lodash";
//  import *as Utils  from '@Cyclope-Utils/index';
import * as shordid from "shortid";
import * as Styled from "@tunnel-components/@sharded/@styled/styled";
import CalendarIcon from "@tunnel-components/@sharded/@widgets/icons/component";
import Scrollbars from "@tunnel-components/@sharded/@widgets/scrollbars";
import CheckBoxNormal from "@tunnel-components/@sharded/widgets/forms/input/checkbox/normal/component";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    selectedOptions,
    selectedFixeArray,
    filter,
    onClearAllElement,
    onClearElement,
    selectedString,
    toggleSusggestion,
    onToggleSuggestion,
    onGetStringValue,
    onSearchValue,
    error,
    isVisible,
    onMouseLeave,
    onMouseEnter,
    placeholder,
  } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name react-custom-scrollbars
   * @infos "https://reactjs.org"
   */

  return (
    <Styled.Container
      onMouseLeave={onMouseLeave}
      style={{
        width: "100%",
        backgroundColor: "transparent",
        overflow: "visible",
        zIndex: 10,
      }}
    >
      {!toggleSusggestion && (
        <Styled.ContainerBalise error={error}>
          <Styled.Input
            style={{ color: "#979797" }}
            onMouseEnter={onMouseEnter}
            onFocus={onMouseEnter}
            maxLength={50}
            autoComplete="OFF"
            type="text"
            onChange={onSearchValue}
            placeholder={placeholder}
          />
          <Styled.Icon
            onMouseEnter={onMouseEnter}
            isrotate={isVisible}
            style={{ width: "10px" }}
          >
            <CalendarIcon arrowSeek={true} color="#808fa3" />
          </Styled.Icon>
        </Styled.ContainerBalise>
      )}
      {toggleSusggestion && (
        <Styled.BoxContainersuggestion
          isVisible={true}
          style={{
            height: "46px",
            cursor: "pointer",
            border: "1px solid #E9EFF4",
          }}
          onMouseEnter={onToggleSuggestion}
        >
          <div
            style={{
              position: "relative",
              display: "inline-block",
              width: "calc(100% - 51px)",
              height: "100%",
            }}
          >
            <div
              style={{
                position: "absolute",
                width: "100%",
                height: "auto",
                transform: "translateY(-50%)",
                top: "50%",
              }}
            >
              {selectedString.filter((elem: any) => elem !== "").length < 1 && (
                <Styled.BoxContainersuggestionText>
                  <span>{i18next.t("selection")}</span>
                </Styled.BoxContainersuggestionText>
              )}

              {selectedString.filter((elem: any) => elem !== "").length >= 1 &&
                selectedString.filter((elem: any) => elem !== "")[0] && (
                  <Styled.BoxContainersuggestionText>
                    <span>
                      {selectedString.filter((elem: any) => elem !== "")[0]}
                    </span>
                  </Styled.BoxContainersuggestionText>
                )}
              {selectedString.filter((elem: any) => elem !== "").length >= 1 &&
                selectedString.filter((elem: any) => elem !== "")[1] && (
                  <Styled.BoxContainersuggestionText>
                    <span>
                      {selectedString.filter((elem: any) => elem !== "")[1]}
                    </span>
                  </Styled.BoxContainersuggestionText>
                )}

              {selectedString.filter((elem: any) => elem !== "").length >=
                3 && (
                <Styled.BoxContainersuggestionText
                  style={{
                    backgroundColor: "rgb(0, 122, 223)",
                    color: "white",
                    border: "none",
                  }}
                >
                  <span>
                    {selectedString.filter((elem: any) => elem !== "").length -
                      1}
                    +{" "}
                  </span>
                </Styled.BoxContainersuggestionText>
              )}
            </div>
          </div>
          <div
            onMouseEnter={onToggleSuggestion}
            style={{
              position: "relative",
              display: "inline-block",
              width: "51px",
              backgroundColor: "#4DA1FF20",
              borderRadius: " 0 2px 2px 0",
              height: "100%",
            }}
          >
            <div
              style={{
                position: "absolute",
                width: "10px",
                transform: "translate(-50%, -50%)",
                left: "50%",
                top: "50%",
              }}
            >
              <CalendarIcon arrowSeek={true} color="#808fa3" />
            </div>
          </div>
        </Styled.BoxContainersuggestion>
      )}

      <Styled.BoxContainer isVisible={isVisible} style={{ height: "auto" }}>
        {!!selectedString &&
          !Lodash.isEmpty(
            selectedString.filter((elem: any) => elem !== "")
          ) && (
            <div
              className="suggestionSelected"
              style={{
                borderBottom: "1px solid rgb(233, 239, 244)",
                width: "100%",
                position: "relative",
                height: "auto",
                paddingBottom: "10px",
              }}
            >
              {selectedString.map((elem: any) => {
                return (
                  <span key={shordid.generate()}>
                    {elem !== "" && (
                      <Styled.BoxContainersuggestionText>
                        <span>{elem}</span>
                        <span
                          style={{
                            cursor: "pointer",
                            display: "inline-block",
                            marginLeft: "5px",
                          }}
                          onClick={onClearElement(elem)}
                        >
                          <svg
                            style={{ transform: "rotate(45deg)" }}
                            viewBox="0 0 24 24"
                            width="1em"
                            height="1em"
                          >
                            <path
                              fill="#a8b4c0"
                              d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0zm4.8 13.2h-3.6v3.6a1.2 1.2 0 0 1-2.4 0v-3.6H7.2a1.2 1.2 0 1 1 0-2.4h3.6V7.2a1.2 1.2 0 1 1 2.4 0v3.6h3.6a1.2 1.2 0 0 1 0 2.4z"
                            />
                          </svg>
                        </span>
                      </Styled.BoxContainersuggestionText>
                    )}
                  </span>
                );
              })}
            </div>
          )}

        <p style={{ width: "100%", position: "relative", margin: "10px 0" }}>
          {i18next.t("suggestion")}
        </p>
        <div
          style={{
            width: "100%",
            position: "relative",
            minHeight: "50px",
            marginTop: "5px",
          }}
        >
          <Scrollbars height="100px" width="100%">
            <div
              style={{ width: "100%", height: "100%", position: "relative" }}
              className="with-3-columns"
            >
              {!Lodash.isUndefined(selectedOptions) &&
                !Lodash.isEmpty(selectedOptions) &&
                !!selectedFixeArray &&
                selectedOptions.map((elem: string, index: number) => {
                  return (
                    <CheckBoxNormal
                      key={shordid.generate()}
                      checked={filter[selectedFixeArray.indexOf(elem)]}
                      onChecked={onGetStringValue(elem)}
                      label={elem}
                      name={`refs--${index}`}
                      id={`refs--${index}`}
                    />
                  );
                })}
            </div>
          </Scrollbars>
        </div>
        <p
          style={{
            width: "100%",
            textAlign: "right",
            position: "relative",
            marginTop: "10px",
          }}
        >
          {!!selectedString &&
            !Lodash.isEmpty(
              selectedString.filter((elem: any) => elem !== "")
            ) && (
              <span
                title="effacer"
                style={{
                  color: "white",
                  borderRadius: "2px",
                  cursor: "pointer",
                  backgroundColor: "#007ADF",
                  padding: "2px 7px",
                }}
                onClick={onClearAllElement}
              >
                {i18next.t("effacer")}
              </span>
            )}
        </p>
      </Styled.BoxContainer>
    </Styled.Container>
  );
};
// initialisation des props

Component.defaultProps = {
  selectedOptions: [],
};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  selectedOptions: any;

  onGetStringValue: any;
  onSearchValue: any;
  isVisible: boolean;
  onMouseLeave: any;
  onMouseEnter: any;
  placeholder: string;
  error?: boolean;
  filter?: any;
  selectedString?: any;
  style?: any;
  isOpen?: any;
  onToggleSuggestion?: any;
  toggleSusggestion?: boolean;
  onClearAllElement?: any;
  onClearElement?: any;
  selectedFixeArray?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/filtre-multiple/component.tsx